import { render } from "./UpdateRegisterService.vue?vue&type=template&id=15a74c2f&ts=true"
import script from "./UpdateRegisterService.vue?vue&type=script&lang=ts"
export * from "./UpdateRegisterService.vue?vue&type=script&lang=ts"

import "./UpdateRegisterService.vue?vue&type=style&index=0&id=15a74c2f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__